import type {SocialPlatform} from 'nutshell-graphql-types';

import {IconAvatar} from '../../avatar/icon-avatar';
import {colors} from '../../colors/colors';
import {faIconCreator} from '../../icon/fa-icon-creator';
import {XSocialIcon} from '../../icon/svg/x-social-icon';
import {PrimaryIconWrapper} from '../../primary-icon-wrapper/primary-icon-wrapper';

import {
    AVATAR_SIZE,
    ICON_SIZE,
    ICON_BACKGROUND_COLOR,
    SOCIAL_PLATFORM_TO_ICON_COLOR,
    SOCIAL_PLATFORM_TO_ICON_NAME,
} from './consts';

export function getUrlRowSocialIcon(
    socialPlatform: SocialPlatform | null | undefined,
    isPrimary?: boolean
): React.ReactNode | undefined {
    if (!socialPlatform) {
        return undefined;
    }

    let IconAvatarComponent: React.ReactNode;

    if (socialPlatform === 'X' || socialPlatform === 'TWITTER') {
        // Special case: our FontAwesome version doesn't have an X icon
        IconAvatarComponent = (
            <IconAvatar
                icon={XSocialIcon}
                iconSize={ICON_SIZE}
                avatarSize={AVATAR_SIZE}
                iconColor={SOCIAL_PLATFORM_TO_ICON_COLOR.X}
                backgroundColor={ICON_BACKGROUND_COLOR}
                shape='square'
            />
        );
    } else {
        const iconName = SOCIAL_PLATFORM_TO_ICON_NAME[socialPlatform];

        if (!iconName) {
            return undefined;
        }

        const Icon = faIconCreator(iconName);
        const iconColor = SOCIAL_PLATFORM_TO_ICON_COLOR[socialPlatform] ?? colors.grey;

        IconAvatarComponent = (
            <IconAvatar
                icon={Icon}
                avatarSize={AVATAR_SIZE}
                iconSize={ICON_SIZE}
                iconColor={iconColor}
                backgroundColor={ICON_BACKGROUND_COLOR}
                shape='square'
            />
        );
    }

    if (isPrimary) {
        return <PrimaryIconWrapper>{IconAvatarComponent}</PrimaryIconWrapper>;
    }

    return IconAvatarComponent;
}
